import Vue from "vue";
import VueRouter from "vue-router";

const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location, onResolve, onReject) {
    if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject);
    return originalPush.call(this, location).catch(err => err);
};
import WebView from "./modules/WebView";


const routes = [
    {
        path: "/",
        redirect: { name: 'WebView' },
        component: () => import("@/view/Index"),
        children: [
            {
                name: "WebView",
                path: "WebView",
                component: () => import("@/view/WebView"),
                redirect: { name: "Home" },
                children: [...WebView]
            },
        ]
    },
]

Vue.use(VueRouter);
const router = new VueRouter({
    mode: 'history',
    routes
})
//全局后置守卫：初始化时执行、每次路由切换后执行
router.afterEach((to, from) => {
    window.scrollTo(0, 0) //路由切换后，页面滚到顶部
    if (to.meta.title) {
        document.title = to.meta.title //修改网页的title
    } else {
        document.title = 'SBOOIP-NET'
    }
})

export default router;